<!-- =========================================================================================
  File Name: BookEdit.vue
  Description: Book Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-book-edit">

    <vs-alert color="danger" title="Book Not Found" :active.sync="book_not_found">
      <span>Book record with id: {{ $route.params.bookSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-book-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="book_data"> -->
    <vx-card title="교재 상세 정보" class="mb-base" v-if="book_data">
      <book-edit-form class="mt-4" :data="book_data" />

    </vx-card>
  </div>
</template>

<script>
import BookEditForm  from './BookEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    BookEditForm
  },
  data () {
    return {
      book_data: null,
      book_not_found: false
    }
  },
  async created () {
    try {
      const bookSeq = this.$route.params.bookSeq
      const { data } = await fetchData(`book/${bookSeq}`)
      // console.log(data);
      this.book_data = data.data
    } catch (error) {
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  } 
}

</script>
